import { useSyncExternalStore } from "react"
import { chatStore } from "./chatStore"
import Launcher from "./Launcher"
import Conversation from "./Conversation"

export default function ChatWidget({
  title,
  subtitle,
  handleNewUserMessage,
  launcherOpenImg,
  launcherCloseImg,
  toolbarSlot,
  children,
}) {
  const state = useSyncExternalStore(chatStore.subscribe, chatStore.getSnapshot)

  return (
    <div className="chatbot-widget-root">
      {state.isOpen && (
        <div className="chatbot-widget-container">
          <Conversation
            title={title}
            subtitle={subtitle}
            messages={state.messages}
            loaderVisible={state.loaderVisible}
            inputDisabled={state.inputDisabled}
            handleNewUserMessage={handleNewUserMessage}
            toolbarSlot={toolbarSlot}
          >
            {children}
          </Conversation>
        </div>
      )}
      <Launcher
        isOpen={state.isOpen}
        launcherOpenImg={launcherOpenImg}
        launcherCloseImg={launcherCloseImg}
        onClick={() => chatStore.toggleOpen()}
      />
    </div>
  )
}
